import { CRM_PUBLIC_BASE_URL, PUBLIC_API_TOKEN } from '../../constants/Configs';
import BaseService from '../../utils/BaseService';

export const getMeetingToekn = (meetingObj: any) => {
  const axios = BaseService.getSharedInstance().axios;
  return axios.get(
    `/crm-communication/meetms/meeting/${meetingObj?.id}/client_token${
      meetingObj.role ? `?role=${meetingObj.role}` : ''
    }`,
    {
      headers: {
        'user-uuid': meetingObj.userUuid,
      },
    }
  );
};
export const getClienttoken = (meetingObj: any) => {
  const axios = BaseService.getSharedInstance().axios;
  return axios.get(
    `/crm-communication/meetms/meeting/${meetingObj?.meetingId}/client_token${
      meetingObj.role ? `?role=${meetingObj.role}` : ''
    }`,
    {
      headers: {
        'user-uuid': meetingObj.userUuid,
      },
    }
  );
};
export const getClientHostToken = (meetingObj: any) => {
  const axios = BaseService.getSharedInstance().axios;
  return axios.get(
    `/crm-communication/meetms/meeting/${meetingObj?.meetingId}/client_token?role=role-doc`,
    {
      headers: {
        'user-uuid': meetingObj?.joineeDetails?.userUuid,
      },
    }
  );
};

export const updateJoinMeetingDetails = (meetingObj: any) => {
  const axios = BaseService.getSharedInstance().axios;
  return axios.post(
    `/crm-communication/meetms/meeting/join`,
    {
      participantId: meetingObj.participantId,
      meetingId: meetingObj.meetingId,
      name: meetingObj.name,
    },
    {
      headers: {'user-uuid': meetingObj?.joineeDetails?.userUuid},
    }
  );
};

export const getThemeConfigData = (accountId: any, subDomain: string) => {
  const axios = BaseService.getSharedInstance().axios;
  return axios
    .post(
      CRM_PUBLIC_BASE_URL + `/getAccountThemes`,
      JSON.stringify({subDomain: subDomain}),
      {
        headers: {
          api_access_token: PUBLIC_API_TOKEN(),
          'x-hasura-account-id':
            accountId,
        },
      }
    )
}


